module.exports = __webpack_public_path__ + "img/happy_at_work.50dfcfbe.png";